// 404 catch-all. Plain centred message — does not redirect.

import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
        background: 'var(--color-page-bg, #f8fafc)',
        color: 'var(--color-text-primary, #0f172a)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <h1 style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>404</h1>
      <p
        style={{
          color: 'var(--color-text-secondary, #475569)',
          marginBottom: '1.5rem',
        }}
      >
        We couldn’t find that page.
      </p>
      <Link
        to="/"
        style={{
          padding: '0.625rem 1rem',
          background: 'var(--color-primary, #0f172a)',
          color: '#ffffff',
          textDecoration: 'none',
          borderRadius: '8px',
          fontWeight: 500,
        }}
      >
        Back to dashboard
      </Link>
    </div>
  );
}
